<div class="container d-flex justify-content-between align-items-center" style="margin-top: 30px">
    <!-- <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems" style="margin-top: -20px">
    </app-linker-route> -->

    <div class="row">
        <div class="form-group has-search mb-0">
            <span class="fa fa-search form-control-feedback"></span>
            <input type="text" class="form-control" [(ngModel)]="serviceName" placeholder="Search by product name"
                (input)="getServiceList(); currentPage = 1" (input)="!serviceName && getServiceList()" />
        </div>
    </div>
</div>
<div class="container mb-5 wrapper-content mt-3" style="padding-left: 0px">
    <sub-category-filter (onSelectCategory)="getsubCatId($event)"></sub-category-filter>

    <div class="row row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 mt-3">
        <ng-container *ngIf="productDetails?.length">
            <div class="col newCardWidth mb-3" style="margin-left: 7px" *ngFor="
          let item of productDetails
            | paginate
              : {
                  itemsPerPage: pageSize,
                  currentPage: currentPage,
                  totalItems: totalItems
                };
          let i = index
        ">
                <div class="innerDiv">
                    <product-card [data]="item" (on_Click)="navigateToViewProduct(item?._id)" [showHeart]="true"
                        (on_Add_Wishlist)="addWishlist($event)"></product-card>
                </div>
            </div>
        </ng-container>
        <!-- replaced !apiLoaded with !isLoading -->
        <ng-container *ngIf="!productDetails?.length && !isLoading">
            <div class="col  mb-3" *ngFor="let item of length(12)">
                <div class="innerDiv">
                    <product-card [data]="item" [showHeart]="true"
                        (on_Add_Wishlist)="addWishlist($event)"></product-card>
                </div>
            </div>
        </ng-container>
        <div *ngIf="apiLoaded" class="no-data" style="text-align: center; display: inline-table; margin-top: 100px">
            <img src="assets/images/notfound.png" alt="No Data Found" class="notfound-img"
                style="width: auto; max-width: 100px; height: auto" />
            <p style="text-align: center; font-size: 20px; font-weight: 500">
                No Data Found
            </p>
        </div>
    </div>
    <div class="custom-pagination mt-2 text-align-right" style="text-align: right"
        *ngIf="totalItems > 15 && !apiLoaded">
        <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
    </div>
</div>